/** Strings owned by the Dashboards page (dashboards/). */
export const DASHBOARDS_STRINGS = {
    'dashboards.title': { en: 'Dashboards', ru: 'Дашборды' },
    'dashboards.tab_operations': { en: 'Operations', ru: 'Реестр операций' },
    'dashboards.failed_to_load_farms': { en: 'Failed to load farms.', ru: 'Не удалось загрузить фермы.' },
    'dashboards.tab_devices': { en: 'Devices', ru: 'Устройства' },
    'dashboards.kind_host': { en: 'Host', ru: 'Хост' },
    'dashboards.kind_aggregator': { en: 'Aggregator', ru: 'Агрегатор' },
    'dashboards.status_online': { en: 'Online', ru: 'Онлайн' },
    'dashboards.status_offline': { en: 'Disconnected', ru: 'Отвалилась' },
    'dashboards.status_farm_offline': { en: 'Farm offline', ru: 'Ферма офлайн' },
    'dashboards.search_placeholder': { en: 'Name, UDID or model', ru: 'Имя, UDID или модель' },
    'dashboards.counters': {
        en: 'Total <b>{total}</b> · online <b>{online}</b> · disconnected <b>{offline}</b> · farm offline <b>{farmOffline}</b>',
        ru: 'Всего <b>{total}</b> · онлайн <b>{online}</b> · отвалились <b>{offline}</b> · ферма офлайн <b>{farmOffline}</b>',
    },
    'dashboards.col_kind': { en: 'Farm type', ru: 'Тип фермы' },
    'dashboards.col_model': { en: 'Model', ru: 'Модель' },
    'dashboards.col_battery': { en: 'Battery', ru: 'Батарея' },
    'dashboards.col_seen': { en: 'Last seen', ru: 'На связи' },
    'dashboards.online_now': { en: 'now', ru: 'сейчас' },
    'dashboards.offline_for': { en: 'offline {age}', ru: 'офлайн {age}' },
    'dashboards.forget': { en: 'Forget', ru: 'Забыть' },
    'dashboards.confirm_forget': {
        en: 'Remove {udid} from the roster? It reappears if the phone connects again.',
        ru: 'Убрать {udid} из списка? Трубка вернётся, если снова подключится.',
    },
    'dashboards.no_devices': { en: 'No devices recorded yet.', ru: 'Устройств пока нет.' },
    'dashboards.no_match': { en: 'No devices match the filters.', ru: 'Нет устройств под фильтры.' },
};
